import styled from "styled-components";
export const Container = styled.div`
  h1 {
    margin: 10px 0 10px 25px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 20px;
      font-weight: 400;
    }
  }
`;
export const Poster = styled.img``;
export const Button = styled.button`
  margin-top: 15px;
  padding: 2px 5px;
`;
